// 预留给ProTable透传
export default {};
